import React, { useEffect } from 'react';
import { sessionRecorder } from '../utils/sessionRecorder';

const SessionRecorder: React.FC = () => {
  useEffect(() => {
    // Start recording when the component mounts
    sessionRecorder.startRecording();

    // Stop recording when the component unmounts
    return () => {
      sessionRecorder.stopRecording();
    };
  }, []);

  return null; // This component doesn't render anything
};

export default SessionRecorder; 